import React from "react";
import { FormControl } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import CustomInput from "../../../components/common/form/CustomInput";
import { AutoSuggest } from "../../../components/common/form/AutoSuggest";
import { CustomNativeSelect } from "../../../components/common/form/CustomNativeSelect";
import { CustomDatePicker } from "../../../components/common/form/CustomDatePicker";
import { CButton } from "../../../components/common/buttons";
import { AVR_STATUS_OPTIONS, AVR_TYPE_OPTIONS } from "../services";
import styles from "../styles.module.scss";

const statusOptions = AVR_STATUS_OPTIONS.filter(item => !!item.value);

export const AvrJournalFilters = ({
  filters,
  contractors = [],
  rowsCount = 0,
  isFetching = false,
  onChange,
  onReset
}) => {
  const contractorOptions = contractors.map(item => ({
    contractor_id: item.contractor_id,
    label: item.bin
      ? `${item.contractor_name} · ${item.bin}`
      : item.contractor_name
  }));

  const onInput = e => onChange(e.target.name, e.target.value);

  return (
    <div className={styles.filters}>
      <FormControl>
        <CustomNativeSelect
          name="status_code"
          label="Статус"
          placeholder={AVR_STATUS_OPTIONS[0].label}
          hidden={false}
          value={filters.status_code}
          options={statusOptions}
          optionValue="value"
          optionKey="value"
          optionDisplay="label"
          handleChange={onInput}
        />
      </FormControl>
      {contractorOptions.length > 1 && (
        <AutoSuggest
          name="contractor_id"
          label="Контрагент"
          list={contractorOptions}
          showKey="label"
          valueKey="contractor_id"
          value={filters.contractor_id}
          onChange={onInput}
        />
      )}
      <AutoSuggest
        name="group_type_code"
        label="Тип"
        list={AVR_TYPE_OPTIONS}
        showKey="label"
        valueKey="value"
        value={filters.group_type_code}
        onChange={onInput}
      />
      <CustomInput
        name="specification_num"
        label="Договор"
        value={filters.specification_num}
        handleChange={onInput}
      />
      <CustomInput
        name="flat_num"
        label="Квартира"
        value={filters.flat_num}
        handleChange={onInput}
      />
      <CustomInput
        name="remont_id"
        label="ID ремонта"
        type="number"
        value={filters.remont_id}
        handleChange={onInput}
      />
      <CustomInput
        name="contragent_avr_id"
        label="ID АВР"
        type="number"
        value={filters.contragent_avr_id}
        handleChange={onInput}
      />
      <CustomDatePicker
        fullWidth
        name="avr_date_from"
        label="Дата с"
        placeholder="Выберите дату"
        value={filters.avr_date_from}
        onChange={onInput}
      />
      <CustomDatePicker
        fullWidth
        name="avr_date_to"
        label="Дата по"
        placeholder="Выберите дату"
        value={filters.avr_date_to}
        onChange={onInput}
      />
      <div className={styles.filters__actions}>
        <span className={styles.filters__count}>
          {isFetching ? "…" : `Найдено: ${rowsCount}`}
        </span>
        <CButton mode="auto" variant="secondary" onClick={onReset}>
          <RefreshIcon fontSize="small" /> Сбросить
        </CButton>
      </div>
    </div>
  );
};
